import BaseModel from '../base/BaseModel.model';
import { UserType } from '@/enums/UserType';
import { RoleRequestStatus } from '@/enums/RoleRequestStatus';

export default class RoleRequest extends BaseModel {

    public userId?: number = 0;
    public userType?: UserType | null = null;
    public description?: string | null = null;
    public roleRequestStatus: RoleRequestStatus | null = RoleRequestStatus.PENDIENT;
    public descriptionChangeRequestStatus?: string | null = null;
    public researchCenterId: number | null = null;
    public rolesIds: Array<number> = [];
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.userId = 0;
        this.researchCenterId = null;
        this.userType = null;
        this.description = null;
        this.roleRequestStatus = RoleRequestStatus.PENDIENT;
        this.descriptionChangeRequestStatus = null;
        this.rolesIds = [];
    }
}